import { styled } from '@mui/material/styles';

export const HeaderWrapper = styled('div', {
  shouldForwardProp: (p) => p !== 'variant',
})<{ variant: string }>(({ theme, variant }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(4.5, 39),
  position: 'relative',
  ...(variant !== 'homepage' && {
    borderBottom: `1px solid ${theme.designTokens.slate[100]}`,
    backgroundColor: theme.designTokens.white,
  }),
  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(4.5, 12),
  },
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(4, 6),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(3, 4),
  },
}));

export const Logo = styled('div')(({ theme }) => ({
  ...theme.typography.body1,
  fontSize: theme.typography.pxToRem(20),
  fontWeight: 600,
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  color: theme.designTokens.slate[900],
  [theme.breakpoints.down(400)]: {
    fontSize: theme.typography.pxToRem(16),
    gap: theme.spacing(1.5),
  },
}));

export const Menu = styled('ul')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(3),
  margin: 0,
  padding: 0,
  listStyle: 'none',
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));


export const LeftSection = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(15.5),
  [theme.breakpoints.down('md')]: {
    gap: 0,
  },
}));

export const ToolsSection = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));
